import React from 'react';
import styled from 'styled-components';
import MainHeaderImage from '../../components/MainHeaderImage';
import getQuestion from '../../api/getQuestion';

export default function AskQuestion() {
  return (
    <PageContainer>
      <MainHeaderImage />
      <h1>Časté dotazy</h1>
      <TextContainer>
        {getQuestion.map((i) => (
          <TextBox key={i.id}>
            <h4>{i.title}</h4>
            <p>{i.text}</p>
          </TextBox>
        ))}
        <h3>Nenašli jste odpověď na Váš dotaz? Prosím kontaktujte nás...</h3>
      </TextContainer>
    </PageContainer>
  );
}

const TextBox = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  p{
    text-align: justify;
  }
`;
const TextContainer = styled.div`
  width: 100%;
  max-width: 1800px;
  padding: 24px;
  margin: 0 auto;
  h3 {text-align: center; margin-top: 48px;}
`;
const PageContainer = styled.div``;
